var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSideBottomImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 149,
    height: 116,
    viewBox: "0 0 149 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.9306 0C8.87696 0 0.726562 8.15017 0.726562 18.204V54.4039C0.726562 64.4575 8.87696 72.6079 18.9306 72.6079H55.1304C56.2042 72.6079 57.2562 72.5148 58.2788 72.3366V54.6294C58.2788 45.6491 64.7811 38.1877 73.3344 36.6966V18.204C73.3344 8.15017 65.1843 0 55.1304 0H18.9306Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0977 46.3632C25.0977 46.3632 29.6043 49.1475 37.12 49.1475C44.636 49.1475 49.1427 46.3632 49.1427 46.3632",
    stroke: "#216CB5",
    strokeWidth: 5.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9723 29.323C27.9723 32.5775 25.2719 35.2202 21.9353 35.2202C18.5988 35.2202 15.8984 32.5775 15.8984 29.323C15.8984 26.0686 18.5988 23.4258 21.9353 23.4258C25.2719 23.4258 27.9723 26.0686 27.9723 29.323ZM58.064 29.323C58.064 32.5775 55.3636 35.2202 52.0271 35.2202C48.6905 35.2202 45.9901 32.5775 45.9901 29.323C45.9901 26.0686 48.6905 23.4258 52.0271 23.4258C55.3636 23.4258 58.064 26.0686 58.064 29.323Z",
    fill: "#216CB5",
    stroke: "#206CB4"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M115.599 39.3392H79.3993C69.3455 39.3392 61.1953 47.4895 61.1953 57.5433V93.7431C61.1953 103.797 69.3455 111.947 79.3993 111.947H115.599C125.653 111.947 133.803 103.797 133.803 93.7431V57.5433C133.803 47.4895 125.653 39.3392 115.599 39.3392Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M85.5625 85.7025C85.5625 85.7025 90.0691 88.4868 97.5851 88.4868C105.101 88.4868 109.608 85.7025 109.608 85.7025",
    stroke: "#216CB5",
    strokeWidth: 5.05,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M88.4371 68.6624C88.4371 71.9168 85.7368 74.5596 82.4002 74.5596C79.0636 74.5596 76.3633 71.9168 76.3633 68.6624C76.3633 65.408 79.0636 62.7654 82.4002 62.7654C85.7368 62.7654 88.4371 65.408 88.4371 68.6624ZM118.529 68.6624C118.529 71.9168 115.828 74.5596 112.492 74.5596C109.155 74.5596 106.455 71.9168 106.455 68.6624C106.455 65.408 109.155 62.7654 112.492 62.7654C115.828 62.7654 118.529 65.408 118.529 68.6624Z",
    fill: "#216CB5",
    stroke: "#216CB5"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M83.606 10.9393C87.2079 12.726 91.9887 10.4286 91.9887 10.4286C91.9887 10.4286 90.9263 5.23502 87.3223 3.4508C83.7202 1.66407 78.9414 3.95892 78.9414 3.95892C78.9414 3.95892 80.0038 9.15253 83.606 10.9393Z",
    fill: "url(#paint0_linear_899_6604)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1884 94.463C29.5393 94.463 30.6345 95.5581 30.6345 96.9091C30.6345 98.2601 29.5393 99.3553 28.1884 99.3553C26.8374 99.3553 25.7422 98.2601 25.7422 96.9091C25.7422 95.5581 26.8374 94.463 28.1884 94.463Z",
    fill: "#666AF6"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M88.6201 21.3695C91.161 21.3695 93.2208 23.4293 93.2208 25.9701C93.2208 28.511 91.161 30.5707 88.6201 30.5707C86.0793 30.5707 84.0195 28.511 84.0195 25.9701C84.0195 23.4293 86.0793 21.3695 88.6201 21.3695Z",
    fill: "#216CB5"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M121.191 35.4871C122.541 35.4871 123.636 34.3924 123.636 33.0421C123.636 31.6917 122.541 30.597 121.191 30.597C119.841 30.597 118.746 31.6917 118.746 33.0421C118.746 34.3924 119.841 35.4871 121.191 35.4871Z",
    fill: "#216CB5"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M145.03 102.832C146.939 102.832 148.486 101.285 148.486 99.376C148.486 97.4674 146.939 95.9202 145.03 95.9202C143.121 95.9202 141.574 97.4674 141.574 99.376C141.574 101.285 143.121 102.832 145.03 102.832Z",
    fill: "#E1E4E5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5119 87.1237C34.911 87.1237 36.8558 85.1788 36.8558 82.7797C36.8558 80.3806 34.911 78.4358 32.5119 78.4358C30.1128 78.4358 28.168 80.3806 28.168 82.7797C28.168 85.1788 30.1128 87.1237 32.5119 87.1237Z",
    fill: "#E1E4E5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M109.2 18.1456C108.707 19.9861 109.799 21.8779 111.639 22.3711C113.48 22.8643 115.372 21.772 115.865 19.9315C116.358 18.091 115.266 16.1991 113.425 15.706C111.585 15.2128 109.693 16.3051 109.2 18.1456Z",
    fill: "#E1E4E5"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M3.53067 78.4996C5.48061 78.4996 7.06134 77.235 7.06134 75.675C7.06134 74.115 5.48061 72.8504 3.53067 72.8504C1.58074 72.8504 0 74.115 0 75.675C0 77.235 1.58074 78.4996 3.53067 78.4996Z",
    fill: "#E1E4E5"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4677 109.812C43.4677 112.924 45.9907 115.447 49.103 115.447C52.2153 115.447 54.7383 112.924 54.7383 109.812C54.7383 106.699 52.2153 104.176 49.103 104.176C45.9907 104.176 43.4677 106.699 43.4677 109.812Z",
    fill: "#E1E4E5"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_899_6604",
    x1: 97.4381,
    y1: 16.5129,
    x2: 67.7284,
    y2: -6.98762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEEEEE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideBottomImg);
export default __webpack_public_path__ + "static/media/SideBottomImg.6aed81304df0a667fa7944f65825261f.svg";
export { ForwardRef as ReactComponent };